import React, { useEffect, useState } from 'react';
import {toast } from 'react-toastify';
import { useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
import Navbar from '../../Navbar';


const TicketDetail = () => {
  const { id } = useParams();
  const [ticket, setTicket] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    axios.get(`/ticketDetails/api/v1/api/tickets/${id}`)
      .then((response) => setTicket(response.data))
      .catch((error) => console.error("Error fetching ticket", error));
  }, [id]);

  const handleStatusChange = (newStatus) => {
    axios.patch(`/ticketDetails/api/v1/api/updatetickets/${id}`, { status: newStatus })
      .then((response) => setTicket(response.data))
      .catch((error) => console.error("Error updating ticket", error));
  };

  if (!ticket) return <div>Loading...</div>;

  return (
    <>
 <div className="">
    <Navbar />
</div>
    <div className='d-flex justify-content-center align-items-center bg-white vh-100'>
    
    <div className='bg-secondary p-3 rounded w-25'>
    <div className='mb-3 text-bg-success text-center form-control-sm rounded-3'>
    <h4>Details Ticket</h4>
      <h1>{ticket.title}</h1>
      <p>{ticket.description}</p>
      <p>Status: {ticket.status}</p>
      <button onClick={() => handleStatusChange('In Progress')}>Mark as In Progress</button>
      <button onClick={() => handleStatusChange('On Hold')}>Mark as On Hold</button>
      <button onClick={() => handleStatusChange('Pending')}>Mark as Pending</button>
      <button onClick={() => handleStatusChange('Resolved')}>Mark as Resolved</button>
    </div>
    </div>
    </div>
    </>
  );
};

export default TicketDetail;
